import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import some from 'lodash/some';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import PageSubNav from '../navigation/PageSubNav';
import useAtScrollPosition from '../../hooks/useAtScrollPosition';
import useIsMobile from '../../hooks/useIsMobile';

const StoreMenu = ({ baseUrl, menu }) => {
  const [t] = useTranslation();
  const stuck = useAtScrollPosition(80);
  const isMobile = useIsMobile();

  const menuEntries = menu.map(entry => ({
    url: `${baseUrl}${entry.url}/`,
    name: entry.name,
    active: entry.active
  }));

  return (
    <PageSubNav
      storeMode
      stuck={stuck}
      mobile={isMobile}
      secondaryMenu={{
        name: t('Store'),
        children: [
          {
            url: baseUrl,
            name: t('Overview'),
            active: !some(menuEntries, 'active')
          },
          ...menuEntries
        ]
      }}
      typeColor="black"
    />
  );
};

StoreMenu.propTypes = {
  baseUrl: PropTypes.string.isRequired
};

export default DisplayComponent(StoreMenu);
